import React, { useEffect, useState } from "react";
import banner from "../Images/about-banner.jpeg";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import "./ContactUs.css";

const ContactUs = () => {

      const [bannerImage, setBannerImage] = useState(""); // Store banner image URL
    
      useEffect(() => {
        // Fetch banner data from API
        fetch("https://api.garudasena.org/api/banners")
          .then((response) => response.json())
          .then((data) => {
            // Find the banner for the "About Us" section
            const aboutUsBanner = data.find((banner) => banner.section === "About Us");
            if (aboutUsBanner) {
              setBannerImage(aboutUsBanner.image); // Set the banner image URL
            }
          })
          .catch((error) => console.error("Error fetching banner data:", error));
      }, []);
      

  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <section className="contact-banner">
        <img src={bannerImage} alt="Contact Us" className="banner-image" />
   
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-container">
          {/* Contact Info */}
<div className="contact-info">
  <h2>Get In Touch</h2>

  <div className="contact-cards">
    {/* Email Card */}
    <div className="info-card">
      <div className="icon-box">
        <FaEnvelope />
      </div>
      <div className="info-text">
        <h4>Email</h4>
        <a href="mailto:seva@garudasena.org">seva@garudasena.org</a>
      </div>
    </div>

    {/* Address Card */}
    <div className="info-card">
      <div className="icon-box">
        <FaMapMarkerAlt />
      </div>
      <div className="info-text">
        <h4>Address</h4>
        <p>H.No – 19-72, Ananda Nilayam, Goutham Nagar. Malkajgiri. Hyderabad. 500047. 
</p>
      </div>
    </div>

    {/* Phone Card */}
    <div className="info-card">
      <div className="icon-box">
        <FaPhoneAlt />
      </div>
      <div className="info-text">
        <h4>Phone</h4>
        <a href="tel:+919666159999">+91-9666159999</a>
      </div>
    </div>
  </div>
</div>

          {/* Contact Form */}
          <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
            <h2>Send Us a Message</h2>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input type="text" id="name" placeholder="name" required />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input type="tel" id="phone" placeholder="phone number" required />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" placeholder="email" required />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" placeholder="Subject" required />
              </div>
            </div>

            <div className="form-group full-width">
              <label htmlFor="message">Write a Message</label>
              <textarea id="message" rows="5" placeholder="Type your message..." required></textarea>
            </div>

            <button type="submit" className="send-btn">Send Message</button>
          </form>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUs;
